function getStoreIdWithoutVersion(id: string): string {
  return id.substring(0, id?.match(/V\d+/)?.index); // removes versions (storeNameV1 -> storeName)
}

export default getStoreIdWithoutVersion;
